import * as type from '@/utvStore/store/mutation-types'
import moment from 'moment'
moment.locale('ja')

const initialState = {
  colorScheme: {},
}

const state = Object.assign({}, initialState)

const getters = {}

const mutations = {
  [type.SET_COLOR_SCHEME](_state, scheme) {
    _state.colorScheme = { ...scheme }
  }
}

const actions = {
  [type.SET_COLOR_SCHEME]({ commit }, scheme) {
    commit(type.SET_COLOR_SCHEME, scheme)
  },
  [type.RESET_COLOR_SCHEME]({ commit }) {
    commit(type.SET_COLOR_SCHEME, {})
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/recommend.js